import PresenterSlideManagementStore from './presenter-slide-management-store';

let presenterSlideManagementStore: PresenterSlideManagementStore | null = null;

const getPresenterSlideManagementStore = (): PresenterSlideManagementStore => {
  if(presenterSlideManagementStore === null) {
    presenterSlideManagementStore = new PresenterSlideManagementStore();
  }

  return presenterSlideManagementStore;
};

export { getPresenterSlideManagementStore };